<template>
    <div></div>
</template>

<script>
export default {
    name: "empty",
    mounted() {
        this.$router.push(this.$route.params.url)
    }
}
</script>

<style scoped>

</style>
